module.exports = __webpack_public_path__ + "static/media/docs.fdc3cd4d.svg";